import getQuestionMaxScore from "pages/ManagementPage/utils/getQuestionMaxScore/getQuestionMaxScore";

export default getQuestionMaxScore;
